import React, { useEffect } from 'react';
import { Prospect } from '../../shared/types';
import { ShoppingBag, Crown, Gift, Sparkles, Bell, ChevronRight, CheckCircle2, Tag } from 'lucide-react';

export const EcommerceApp: React.FC<{ prospect: Prospect }> = ({ prospect }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 font-sans text-zinc-900">
      <div className="w-[390px] h-[844px] bg-[#FAFAFA] rounded-[2.5rem] relative overflow-hidden border-[12px] border-zinc-800 flex flex-col justify-between">
        
        {/* Top Header App / Cashback */}
        <div>
           {/* Top Status Bar */}
           <div className="h-12 flex items-center justify-between px-8 text-xs font-medium pt-2 text-zinc-600">
              <span>16:20</span>
              <div className="flex gap-1.5 items-center">
                 <div className="w-4 h-3 bg-current rounded-sm"></div>
                 <div className="w-3 h-3 bg-current rounded-full"></div>
              </div>
           </div>

           <div className="px-6 pt-2 pb-4">
              <div className="flex justify-between items-center mb-6">
                 <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#111111] text-white flex items-center justify-center font-black">
                       <Crown className="w-5 h-5 text-[#D4AF37]" />
                    </div>
                    <div>
                       <p className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold">Clube VIP & Fidelidade</p>
                       <h1 className="font-heading font-black text-sm text-[#111111]">{prospect.trade_name}</h1>
                    </div>
                 </div>
                 <div className="w-9 h-9 rounded-xl bg-white border border-zinc-200 flex items-center justify-center text-zinc-700">
                    <Bell className="w-4 h-4" />
                 </div>
              </div>

              {/* Card Cartão VIP & Cashback - STRICT NO SHADOWS */}
              <div className="bg-[#111111] text-white p-5 rounded-xl mb-6 border border-zinc-800">
                 <div className="flex justify-between items-start mb-4">
                    <span className="bg-[#D4AF37] text-black px-2.5 py-0.5 rounded text-[10px] font-black uppercase">Membro Black</span>
                    <Sparkles className="w-4 h-4 text-[#D4AF37]" />
                 </div>
                 <span className="text-[10px] text-zinc-400 font-bold uppercase tracking-widest block mb-1">Seu Saldo de Cashback Disponível</span>
                 <h3 className="text-3xl font-black font-heading text-white mb-4">R$ 145,90</h3>
                 
                 <div className="bg-zinc-900 p-3 rounded-lg border border-zinc-800 flex items-center justify-between text-xs">
                    <span className="text-zinc-400">Válido até: 30/11/2026</span>
                    <span className="font-bold text-[#D4AF37]">Resgatar no Carrinho</span>
                 </div>
              </div>

              {/* Cupons Secretos da Semana */}
              <h3 className="font-heading font-bold text-xs uppercase tracking-wider text-zinc-500 mb-3">Cupons Exclusivos do App</h3>
              <div className="space-y-3">
                 <div className="bg-white border border-zinc-200 p-4 rounded-xl flex items-center justify-between">
                    <div className="flex items-center gap-3">
                       <div className="w-9 h-9 rounded-lg bg-emerald-50 border border-emerald-200 flex items-center justify-center text-[#047857]">
                          <Tag className="w-4 h-4" />
                       </div>
                       <div>
                          <h5 className="font-bold text-xs text-[#111111]">15% OFF em Lançamentos</h5>
                          <p className="text-[10px] text-zinc-500">Cupom: <span className="font-mono font-bold text-[#047857]">VIP15</span></p>
                       </div>
                    </div>
                    <button className="bg-[#111111] text-white text-[10px] font-bold px-3 py-1.5 rounded-lg border border-[#111111]">
                       Copiar
                    </button>
                 </div>

                 <div className="bg-white border border-zinc-200 p-4 rounded-xl flex items-center justify-between">
                    <div className="flex items-center gap-3">
                       <div className="w-9 h-9 rounded-lg bg-amber-50 border border-amber-200 flex items-center justify-center text-amber-700">
                          <Gift className="w-4 h-4" />
                       </div>
                       <div>
                          <h5 className="font-bold text-xs text-[#111111]">Brinde Exclusivo de Aniversário</h5>
                          <p className="text-[10px] text-zinc-500">Nas compras acima de R$ 300</p>
                       </div>
                    </div>
                 </div>
              </div>

           </div>
        </div>

        {/* Footer App */}
        <div className="p-6 bg-white border-t border-zinc-200">
           <button className="w-full bg-[#111111] text-white py-3 rounded-xl font-bold text-xs uppercase tracking-wider border border-[#111111] flex items-center justify-center gap-2">
              <ShoppingBag className="w-4 h-4" />
              Usar Cashback na Loja
           </button>
        </div>

      </div>
    </div>
  );
};
